/**
 * Universal subscription API client.
 *
 * Backend: see /app/backend/services/subscription_service.py
 * Endpoints all under: ${REACT_APP_BACKEND_URL}/api/v1/subscriptions
 */

const API = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API}/api/v1/subscriptions`;

async function postJson(path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, data };
}

async function getJson(path) {
  const res = await fetch(`${BASE}${path}`);
  const data = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, data };
}

export const subscriptionsApi = {
  /** Returns array of { _id, name, short_description, ... } */
  getLists: () => getJson('/lists'),

  /**
   * Step 1: send 6-digit code to email.
   * @param {{email,list_id,first_name?,last_name?,source,source_article_uid?,website?}} payload
   *   website is the honeypot field — leave empty for real users.
   */
  request: (payload) => postJson('/request', payload),

  /** Step 2: verify the 6-digit code. */
  verify: ({ verification_id, code }) => postJson('/verify', { verification_id, code }),

  /** Preference center — uses master_token in the URL */
  getPreferences: (token) => getJson(`/preferences/${encodeURIComponent(token)}`),
  updatePreferences: (token, changes) => postJson(`/preferences/${encodeURIComponent(token)}`, { changes }),

  /** Kill all subscriptions for a token */
  unsubscribeAll: (token) => postJson(`/unsubscribe-all/${encodeURIComponent(token)}`, {}),
};
